import { reduxForm } from 'redux-form';
import { connect } from 'react-redux'
import { fetchSalesInventoryInfo, fetchItemSalesHistory, setSaleFavoriteRowValue } from '../../actions/sales_actions';
import { setPromoRowValue } from '../../actions/promotions_actions';
import SalesInventoryInfo from '../../components/Sales/salesInventoryInfo';

function mapStateToProps(state) {
  return {
    salesInventoryInfo: state.salesOrders.salesInventoryInfo,
    salesInventoryInfoIsLoading: state.salesOrders.salesInventoryInfoIsLoading,
    salesInventoryInfoError: state.salesOrders.salesInventoryInfoError,
  }
}

const salesInventoryInfo = reduxForm({
  form: 'salesInventoryInfo',
})(SalesInventoryInfo);

export default connect(mapStateToProps, { fetchSalesInventoryInfo, fetchItemSalesHistory, setPromoRowValue, setSaleFavoriteRowValue })(salesInventoryInfo);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/salesInventoryInfo.jsx